import { render, staticRenderFns } from "./SignupSectionBasic.vue?vue&type=template&id=026dc8e7"
import script from "./SignupSectionBasic.vue?vue&type=script&lang=js"
export * from "./SignupSectionBasic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports